@let showBadgesLCCEnabled = this.showBadgesLCCEnabled();
@let company = this.company();
@let workflowOrigin = this.workflowOrigin();

<div class="company-container">
    <div class="details-badges-wrapper" [class.hide-badges-area]="hasNoBadges() || !showBadgesLCCEnabled">
        <div class="company-details clickable-area" (click)="companySelected.emit(company.addressId)">
            <div class="row" [class.collapse-stars]="company.ratingCount < 5">
                <div class="name">{{ company.name }}</div>

                <div class="stars-wrapper">
                    @if (company.ratingCount >= 5) {
                        <warema-rating-stars [ratingCount]="company.ratingCount" [ratingStars]="company.ratingStars" />
                    }
                </div>
            </div>

            <div class="row address-row">
                <div class="full-address">
                    <div class="address-text">{{ company.fullAddress }}</div>

                    <div class="distance">
                        <warema-svg-icon
                            filePath="shared-assets/icons/location.svg"
                            height="20"
                            width="13"
                            [attr.aria-label]="'ARIA-LABEL-LOCATION' | translate"
                        />
                        <div class="distance-label">{{ company.distance }}</div>
                    </div>
                </div>
                <div class="google-link">
                    <span class="google-link-source">{{ 'GOOGLE_SOURCE' | translate }}: &nbsp;</span
                    ><a [href]="company.mapsLink">Google <warema-icon icon="beakRight" /></a>
                </div>
            </div>
        </div>
        <div class="badges-action-buttons-wrapper">
            <div class="badges clickable-area" (click)="companySelected.emit(company.addressId)">
                @if (showBadgesLCCEnabled) {
                    <warema-company-badges [company]="company" />
                }
            </div>

            @if (workflowOrigin === workflowOriginEnum.SunCenter) {
                <div class="sun-center-actions">
                    <warema-button
                        class="open-business-card-btn"
                        type="tertiary"
                        [iconRight]="'externalLink'"
                        [id]="'go-to-business-card-btn-' + company.addressId"
                        [text]="'COMPANY_SEARCH.FURTHER_INFORMATION' | translate"
                        (click)="openFurtherDetails()"
                    />

                    <div class="label-qr-code-wrapper">
                        <div class="contact-dealer">{{ 'COMPANY_SEARCH.CONTACT_SPECIALIST_DEALER' | translate }}</div>
                        <warema-qr-code [data]="businessCardUrlWithParameters()" [width]="95" />
                    </div>
                </div>
            } @else if (workflowOrigin === workflowOriginEnum.SunExperienceManager) {
                <div class="action-buttons">
                    @if (showQuoteRequestButton()) {
                        <warema-button
                            class="request-offer-btn"
                            size="large"
                            type="tertiary"
                            [iconRight]="'checklist'"
                            [id]="'request-offer-btn-' + company.addressId"
                            [text]="'COMPANY_SEARCH.REQUEST_A_QUOTE' | translate"
                            (click)="requestOffer.emit(company)"
                        />
                    }

                    <warema-button
                        class="open-business-card-btn"
                        type="tertiary"
                        [iconRight]="'externalLink'"
                        [id]="'go-to-business-card-btn-' + company.addressId"
                        [text]="'COMPANY_SEARCH.FURTHER_INFORMATION' | translate"
                        (click)="openFurtherDetails()"
                    />
                </div>
            } @else {
                <div class="action-buttons">
                    @if (showQuoteRequestButton()) {
                        <warema-button
                            class="request-offer-btn"
                            size="large"
                            [iconRight]="'checklist'"
                            [id]="'request-offer-btn-' + company.addressId"
                            [text]="'COMPANY_SEARCH.REQUEST_A_QUOTE' | translate"
                            (click)="requestOffer.emit(company)"
                        />
                    }

                    @if (showAppointmentButton()) {
                        <warema-button
                            class="create-appointment-btn"
                            size="large"
                            [iconRight]="'calendar'"
                            [id]="'create-appointment-btn-' + company.addressId"
                            [text]="'COMPANY_SEARCH.CREATE_APPOINTMENT' | translate"
                            (click)="createAppointment.emit(company)"
                        />
                    }

                    <warema-button
                        class="open-business-card-btn"
                        type="tertiary"
                        [iconRight]="'externalLink'"
                        [id]="'go-to-business-card-btn-' + company.addressId"
                        [text]="'COMPANY_SEARCH.FURTHER_INFORMATION' | translate"
                        (click)="openFurtherDetails()"
                    />
                </div>
            }
        </div>
    </div>
</div>
